export default function useDetectOS() {
  const isWindows = () => navigator.userAgent.includes('Win');
  return { isWindows };
}
